import React, { useEffect, useState, useRef } from 'react'
import { useOrder } from '../../Providers/OrderProvider';
import { CheckBox } from 'devextreme-react/check-box';
import SelectBox from 'devextreme-react/select-box';
import { Form } from 'react-bootstrap';
import { daysOfWeek } from '../../data.js'
import DateBox from 'devextreme-react/date-box';
import { locale } from "devextreme/localization";
import { format } from 'date-fns';
import { useCustomer } from '../../Providers/CustomerProvider.jsx';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../Providers/CartProvider.jsx';
import { useAuth } from '../../Providers/AuthProvider.jsx';
import AddEditAuthorizedPerson from '../MyAccount/AuthorizedPersonsPanel/AddEditAuthorizedPerson.jsx';
import { ConvertPriceToString } from '../../Helpers/CustomConverter.jsx';
import dxSelectBox from 'devextreme/ui/select_box';
import { disableSaturdayAndSundays } from '../../Helpers/DateBoxHelpers.jsx';
import { toast } from 'react-toastify';
import { useWarehouse } from '../../Providers/WarehouseProvider.jsx';
import { useParams } from '../../Providers/ParamsProvider.jsx';
import AddEditDeliveryAddress from '../MyAccount/AddressesPanel/AddEditDeliveryAddress.jsx';
import useAttachmentUploader from './Hooks/Attachment/useAttachmentUploader.jsx';
import { MdClear } from "react-icons/md";
import { OverlayTrigger, Popover } from "react-bootstrap";
import PaymentDataModal from '../Components/Modals/PaymentDataModal.jsx';
import { useOffers } from '../../Providers/OffersProvider.jsx';

locale("pl")

const DeliveryAndPayment = ({ handleSetWarningMessage }) => {
    const selectWarehouseRef = useRef(null)
    const dateBoxRef = useRef(null)
    const { availabilityCutoffTime, handleCheckIsWorkingDay } = useParams()
    const { orderInfo, setOrderInfo } = useOrder()
    const { addresses, authorizedPersons, handleGetDeliveryAddresses, handleGetPeopleAuthorizedToCollectDelivery } = useCustomer()
    const { availableWarehousesByOTD, selectedWarehouse, handleSetAvailableWarehousesByOTD } = useWarehouse()
    const { authState } = useAuth()
    const [handlingUser, setHandlingUser] = useState({ firstName: '', lastName: '', position: '', email: '', phoneNumber: '', isExpAuthorization: false, expirationDate: '' })
    const [handlingAddress, setHandlingAddress] = useState({ name: '', street: '', zipCode: '', city: '', email: '', phone: '', recNo: 0, isExpAddress: false, expirationDate: '' })
    const [showAddNewAddress, setShowAddNewAddress] = useState(false)
    const [showAddNewPerson, setShowAddNewPerson] = useState(false)
    const [isCustomDate, setIsCustomDate] = useState(false)
    const [customExpectedDateValue, setCustomExpectedDateValue] = useState(null)
    const [checkBoxes, setCheckBoxes] = useState([])
    const [minDate, setMinDate] = useState(new Date())
    const [newAddedAuthorizedPersonRecNo, setNewAddedAuthorizedPersonRecNo] = useState(null) //Logika wybrania w selectBoxa nowo dodaną osobę upoważnioną
    const [newAddedAddressRecNo, setNewAddedAddressRecNo] = useState(null) //Logika wybrania w selectBoxa nowo dodany adres
    const [customDateOrder, setCustomDateOrder] = useState(1000); // wartość początkowa


    useEffect(() => {
        handlePreparePage()
    }, [])

    useEffect(() => {
        setCheckBoxes(prev =>
            prev.map((checkbox) =>
                React.cloneElement(checkbox, {
                    value: orderInfo.expectedDeliveryTime === checkbox.props.text,
                })
            )
        )
        disableClientDeliveryForTodayOrders()
    }, [orderInfo.expectedDeliveryTime])

    useEffect(() => {
        disableClientDeliveryForTodayOrders()
    }, [orderInfo.expectedDeliveryTime, orderInfo.deliveryType])

    useEffect(() => {
        if (authorizedPersons.length > 0) {
            setOrderInfo(prev => ({
                ...prev,
                authorizedPersons: authorizedPersons[0]
            }))
        }
    }, [authorizedPersons])

    useEffect(() => {
        if (orderInfo.deliveryType == 'Odbiór w hurtowni') {
            const warehousesIncludeElement = availableWarehousesByOTD.some(w => w.id === orderInfo.deliveryAddress.id)
            if (!warehousesIncludeElement) {
                handleSetWarningMessage('Dokonaj wyboru magazynu w górnym pasku, z którego chcesz odebrać towar. Sprawdź dostępność towaru na wybranym magazynie.')
                setOrderInfo(prev => ({
                    ...prev,
                    deliveryAddress: null,
                    deliveryType: '',
                }))
            }
            else {
                if (orderInfo.expectedDeliveryTime && checkBoxes.length > 0) {
                    const extractDate = (text) => text.split(' ')[0]
                    const isFirstSelected = extractDate(orderInfo.expectedDeliveryTime) === extractDate(checkBoxes[0].props.text)
                    if (isFirstSelected) {
                        handleSetWarningMessage('Uwaga wybrałeś opcję odbioru osobistego w terminie realizacji do 24H, sprawdź, czy wybrany magazyn jest poprawny.')
                    }
                }
            }
        }
    }, [availableWarehousesByOTD])

    useEffect(() => {
        handleSetAvailableWarehousesByOTD()
    }, [selectedWarehouse])

    useEffect(() => {
        if (newAddedAuthorizedPersonRecNo && authorizedPersons) {
            let newAddedPerson = authorizedPersons.find(x => x.recNo === newAddedAuthorizedPersonRecNo)
            if (newAddedPerson) {
                setOrderInfo(prev => ({
                    ...prev,
                    authorizedPersons: newAddedPerson
                }))
                setNewAddedAuthorizedPersonRecNo(null)
            }
        }
    }, [authorizedPersons])

    useEffect(() => {
        if (newAddedAddressRecNo && addresses) {
            let newAddedAddress = addresses.find(x => x.recNo === newAddedAddressRecNo)
            if (newAddedAddress) {
                handleCheckboxChange('Dostawa do klienta', 'deliveryType')
                setOrderInfo(prev => ({
                    ...prev,
                    deliveryAddress: newAddedAddress
                }))
                setNewAddedAddressRecNo(null)
            }
        }
    }, [addresses])

    useEffect(() => {
        setOrderInfo(prev => ({
            ...prev,
            isCustomDeliveryTime: isCustomDate
        }))
    }, [isCustomDate])

    /**
     * DK : Funkcja nie pozwala złożyć zamówienia z wysyłką jeżeli odbiór jest <= 24H 
     */
    const disableClientDeliveryForTodayOrders = () => {
        if (orderInfo.deliveryType === 'Dostawa do klienta' && orderInfo.expectedDeliveryTime && checkBoxes.length > 0) {
            const extractDate = (text) => text.split(' ')[0]
            const isFirstSelected = extractDate(orderInfo.expectedDeliveryTime) === extractDate(checkBoxes[0].props.text)
            if (isFirstSelected) {
                handleSetWarningMessage('Wysyłka do klienta nie jest możliwa w terminie realizacji zamówienia poniżej 24H, proszę zmienić oczekiwany termin dostawy lub wybrać odbiór w hurtowni')
                setOrderInfo(prev => ({
                    ...prev,
                    deliveryAddress: null,
                    deliveryType: null,
                }))
            }
        }
    }

    const handlePreparePage = () => {
        window.scrollTo(0, 0)
        generateDateCheckBoxes()

        if (orderInfo.isCustomDeliveryTime) {
            setIsCustomDate(true)
            const dateStr = orderInfo.expectedDeliveryTime?.split(' ')[0]
            if (dateStr) {
                const parsed = new Date(dateStr)
                setCustomExpectedDateValue(parsed)
            }
        }
        if (addresses.length === 0) {
            handleGetDeliveryAddresses(true)
        }
        if (authorizedPersons.length === 0) {
            handleGetPeopleAuthorizedToCollectDelivery()
        }
    }

    const generateDateCheckBoxes = async () => {
        const tmpCheckBoxes = []
        const now = new Date()
        const currentHour = now.getHours()
        const currentMinute = now.getMinutes()
        let baseDate = new Date(now)

        let isTodayIsWorkingDay = await handleCheckIsWorkingDay(baseDate)
        const [cutoffHourStr, cutoffMinuteStr] = availabilityCutoffTime.split(':') //Uwzględnienie parametru z datą od kolejnego dnia
        const cutoffHour = parseInt(cutoffHourStr, 10)
        const cutoffMinute = parseInt(cutoffMinuteStr, 10)
        const isBeforeCutoff = currentHour < cutoffHour || (currentHour === cutoffHour && currentMinute <= cutoffMinute);

        if (isBeforeCutoff && isTodayIsWorkingDay) { //tutaj petla pod dniach pracujacych
            baseDate.setDate(baseDate.getDate()) // Ustawienie daty bazowej na dzisiaj
        }
        else {
            baseDate.setDate(baseDate.getDate() + 1) // Ustawienie daty bazowej na jutro
        }

        const tmpMinDate = new Date(baseDate)
        tmpMinDate.setDate(tmpMinDate.getDate() + 6)
        let lastRenderedDay = new Date()
        let loopEntranceNumber = 5
        for (let i = 0; i < loopEntranceNumber; i++) {
            const date = new Date(baseDate)
            date.setDate(date.getDate() + i)
            if (!(await handleCheckIsWorkingDay(date))) {
                loopEntranceNumber++
                continue
            }
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0")
            const day = String(date.getDate()).padStart(2, "0")
            const dayOfWeek = daysOfWeek[date.getDay()]
            const checkboxText = `${year}-${month}-${day} (${dayOfWeek})`
            tmpCheckBoxes.push(
                <CheckBox
                    key={i}
                    textPosition="before"
                    text={checkboxText}
                    className="custom-checkbox mt-1 mb-1"
                    onValueChange={() => handleCheckboxChange(checkboxText, 'expectedDeliveryTime')}
                    value={orderInfo.expectedDeliveryTime === checkboxText}
                    style={{ order: 1 + i }}
                    tabIndex={i + 1}
                />
            )
            lastRenderedDay = date
        }
        tmpMinDate.setDate(lastRenderedDay.getDate() + 1)
        setCheckBoxes(tmpCheckBoxes)
        setMinDate(tmpMinDate)
        setCustomDateOrder(tmpCheckBoxes + 1)
    }

    const handleCheckboxChange = (value, param) => {
        setOrderInfo(prev => ({
            ...prev,
            [param]: value
        }))
        if (param === 'expectedDeliveryTime') {
            setIsCustomDate(false)
        }

        let elementId = ''

        switch (value) {
            case 'Dostawa do klienta':
                elementId = 'addresses-select-box'
                break;
            case 'Odbiór w hurtowni':
                elementId = 'warehouses-select-box'
                break;
        }
        const element = document.getElementById(elementId)
        if (element) {
            const instance = dxSelectBox.getInstance(element)
            handleSelectBoxChange(instance.option('value'), 'deliveryAddress')
        }
    }
    const handleSelectBoxChange = (e, param) => {
        setOrderInfo(prev => ({
            ...prev,
            [param]: e
        }))
    }
    const handleCommentChange = (e) => {
        setOrderInfo(prev => ({
            ...prev,
            comment: e.target.value
        }))
    }
    const handleDateChange = async (e) => {
        if (e) {
            if (!(await handleCheckIsWorkingDay(new Date(new Date(e).setDate(new Date(e).getDate() + 1))))) {
                toast.warning('W wybranym dniu magazyn jest nieczynny. Proszę wybrać inny termin dostawy.')
                if (dateBoxRef.current) {
                    dateBoxRef.current.instance.reset()
                }
            }
            else {
                const formattedDate = format(e, 'yyyy-MM-dd')
                const dayName = daysOfWeek[new Date(e).getDay()]
                setOrderInfo(prev => ({
                    ...prev,
                    expectedDeliveryTime: `${formattedDate} ${'('} ${dayName} ${')'}`
                }))
                setCustomExpectedDateValue(e)
                setIsCustomDate(true)
            }
        }
    }
    const generateExpectedDeliveryTimeSection = () => {

        const handleCustomDateChange = (val) => {
            setIsCustomDate(val)
            setOrderInfo(prev => ({
                ...prev,
                isCustomDeliveryTime: val,
                ...(val ? { expectedDeliveryTime: null } : {})
            }))
        }

        return (
            <div className="d-flex flex-column">
                <div className='d-flex flex-column'>
                    {checkBoxes}
                </div>
                <div className='d-flex flex-column'>
                    <CheckBox
                        style={{ order: customDateOrder }}
                        textPosition="before"
                        text="Podaj własny"
                        className="custom-checkbox mt-1 mb-1"
                        value={isCustomDate}
                        onValueChange={(val) => handleCustomDateChange(val)}
                    />
                    {isCustomDate && (
                        <DateBox
                            ref={dateBoxRef}
                            pickerType='calendar'
                            className="mt-1"
                            type="date"
                            placeholder="Podaj własną datę"
                            style={{ order: customDateOrder + 1 }}
                            displayFormat="yyyy-MM-dd"
                            acceptCustomValue={false}
                            onValueChange={handleDateChange}
                            min={minDate}
                            value={customExpectedDateValue}
                            disabledDates={disableSaturdayAndSundays}
                            calendarOptions={{
                                maxZoomLevel: 'month',
                                minZoomLevel: 'month'
                            }}
                        />
                    )}
                </div>
            </div>
        )
    }

    let otdText = orderInfo.deliveryType == 'Odbiór w hurtowni' ? 'Termin odbioru' : 'Oczekiwany termin dostawy'

    return (
        <>
            <AddEditDeliveryAddress
                handlingAddress={handlingAddress}
                setHandlingAddress={setHandlingAddress}
                isChangeAddressVisible={showAddNewAddress}
                setisChangeAddressVisible={setShowAddNewAddress}
                setNewAddedAddressRecNo={setNewAddedAddressRecNo}
            />
            <AddEditAuthorizedPerson
                handlingUser={handlingUser}
                setHandlingUser={setHandlingUser}
                isAddPersonVisible={showAddNewPerson}
                setIsAddPersonVisible={setShowAddNewPerson}
                setNewAddedAuthorizedPersonRecNo={setNewAddedAuthorizedPersonRecNo}
            />
            <div className="main-container-holder">
                <div className="row">
                    <h3 className='mb-2 mt-2'>Dostawa</h3>
                    <div className="col-12 col-lg-6 d-flex flex-column">
                        <CheckBox
                            textPosition="before"
                            text='Dostawa do klienta'
                            className="custom-checkbox mt-2"
                            value={orderInfo.deliveryType === 'Dostawa do klienta'}
                            onValueChange={() => handleCheckboxChange('Dostawa do klienta', 'deliveryType')}
                            readOnly={true}
                            style={{ order: 1 }}
                        />
                        <SelectBox
                            id='addresses-select-box'
                            value={orderInfo.deliveryAddress}
                            dataSource={addresses}
                            displayExpr={(item) =>
                                item ? [item.name, item.street, item.houseNum, item.localNum, item.city].filter((field) => field).join(' ') : ''
                            }
                            placeholder="Wybierz adres"
                            showClearButton={false}
                            className="cart-page-select-box mt-3"
                            noDataText='Brak adresów'
                            onValueChange={(e) => {
                                handleSelectBoxChange(e, 'deliveryAddress')
                                handleCheckboxChange('Dostawa do klienta', 'deliveryType')
                            }}
                            style={{ order: 20 }}

                        />
                        <button className='btn-app-secondary mt-3' onClick={() => { setShowAddNewAddress(true) }} style={{ order: 30 }}>Dodaj nowy adres</button>
                    </div>
                    <div className="col-12 col-lg-6 d-flex flex-column mt-4 mt-lg-0">
                        <CheckBox
                            textPosition="before"
                            text='Odbiór w hurtowni'
                            className="custom-checkbox me-5 mt-2"
                            onValueChange={() => handleCheckboxChange('Odbiór w hurtowni', 'deliveryType')}
                            value={orderInfo.deliveryType === 'Odbiór w hurtowni'}
                            readOnly={true}
                            style={{ order: 1 }}
                        />
                        <SelectBox
                            ref={selectWarehouseRef}
                            id='warehouses-select-box'
                            dataSource={availableWarehousesByOTD}
                            value={orderInfo.deliveryAddress}
                            placeholder="Wybierz hurtownię"
                            displayExpr={(item) => item ? `${item.name} ${item.whAddress}` : ''}
                            showClearButton={false}
                            className="cart-page-select-box mt-3"
                            noDataText='Brak hurtowni'
                            onValueChange={(e) => {
                                handleSelectBoxChange(e, 'deliveryAddress')
                                handleCheckboxChange('Odbiór w hurtowni', 'deliveryType')
                            }}
                            readOnly={false}
                            style={{ order: 20 }}
                        />
                    </div>
                </div>
                <div className="row">
                    <h3 className='mt-4'>Osoba upoważniona do odbioru towaru</h3>
                    <div className='col-12 col-lg-6 d-flex flex-column'>
                        <SelectBox
                            id='authorized-persons-select-box'
                            dataSource={authorizedPersons}
                            value={orderInfo.authorizedPersons}
                            placeholder="Wybierz"
                            displayExpr={(item) => item ? `${item.name} ${item.surname}` : ''}
                            showClearButton={false}
                            className="cart-page-select-box mt-3"
                            noDataText='Brak danych'
                            onValueChange={(e) => handleSelectBoxChange(e, 'authorizedPersons')}
                        />
                        <button className='btn-app-secondary mt-3' onClick={() => { setShowAddNewPerson(true) }}>Dodaj nową osobę</button>
                    </div>
                </div>
            </div>
            <div className='row mt-2'>
                <div className="col-12 col-lg-6">
                    <div className="main-container-holder me-md-1">
                        <h3 className='mb-3'>{otdText}</h3>
                        {generateExpectedDeliveryTimeSection()}
                    </div>
                </div>
                <div className="col-12 col-lg-6">
                    <div className="main-container-holder mt-3 mt-lg-0">
                        <h3 className='mb-3'>Opcje dostawy</h3>
                    </div>
                </div>
            </div>
            <div className="main-container-holder mt-2">
                <PaymentMethodComponent
                    orderInfo={orderInfo}
                    handleCheckboxChange={handleCheckboxChange}
                    authState={authState}
                />
            </div>
            <div className="main-container-holder mt-2">
                <div className="col-12">
                    <h3 className='mb-3'>Notatki własne</h3>
                    <Form.Control
                        as="textarea"
                        placeholder="Notatka"
                        style={{ height: '100px', whiteSpace: 'pre-wrap' }}
                        maxLength={5000}
                        value={orderInfo.comment}
                        onChange={handleCommentChange}
                    />
                    <div className="row mt-3 ">
                        <AttachmentSection
                            orderInfo={orderInfo}
                            setOrderInfo={setOrderInfo}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

const PaymentMethodComponent = ({ orderInfo, handleCheckboxChange, authState }) => {

    let isNotConfirmedUser = !authState.user || !authState.user.isConfirmed ? true : false
    let blockNonImmediatePayments = isNotConfirmedUser && !authState.user.isOperator ? 'collapse' : ''

    return (<>
        <div className="row">
            <h3 className='mb-3'>Płatność</h3>
            {!blockNonImmediatePayments &&
                <CreditInfoComponent
                    orderInfo={orderInfo}
                    handleCheckboxChange={handleCheckboxChange}
                    authState={authState}
                />
            }
            <div className={`col-12 col-lg-6 d-flex flex-column `}>
                <CheckBox
                    textPosition="before"
                    text='Zapłać w hurtowni przy odbiorze'
                    className="custom-checkbox me-5"
                    onValueChange={() => handleCheckboxChange('Zapłać w hurtowni przy odbiorze', 'payment')}
                    value={orderInfo.payment === 'Zapłać w hurtowni przy odbiorze'}
                />
                <div className='d-flex flex-column' style={{ order: 22 }}>
                    <span>W naszych hurtowniach możesz zapłacić gotówką, kartą lub blikiem.</span>
                </div>
            </div>
            <div className={`col-12 col-lg-6 mb-3 mt-2 mt-lg-0`}>
                <CheckBox
                    textPosition="before"
                    text='Przelew tradycyjny'
                    className="custom-checkbox me-5"
                    onValueChange={() => handleCheckboxChange('Przelew tradycyjny', 'payment')}
                    value={orderInfo.payment === 'Przelew tradycyjny'}
                />
            </div>
            {/* <div className={`col-12 col-lg-6 mb-3 mt-2 mt-lg-0`}>
                <CheckBox
                    textPosition="before"
                    className="custom-checkbox me-2"
                    onValueChange={() => handleCheckboxChange('Płatności on-line - Autopay', 'payment')}
                    value={orderInfo.payment === 'Płatności on-line - Autopay'}
                />
                <img src='/Logo-standard.png' style={{ maxWidth: '75px', maxHeight: '75px', objectFit: 'contain' }} />
                <span> - przelewy on-line, Blik, płatności mobilne</span>
            </div> */}
            {/* <div className={`col-12 col-lg-6 mb-3 mt-2 mt-lg-0`}>
                <CheckBox
                    textPosition="before"
                    text='Płatność kartą'
                    className="custom-checkbox me-5"
                    onValueChange={() => handleCheckboxChange('Płatności kartą - Autopay', 'payment')}
                    value={orderInfo.payment === 'Płatności kartą - Autopay'}
                />
            </div> */}
        </div>
    </>)
}

const CreditInfoComponent = ({ orderInfo, handleCheckboxChange, authState }) => {
    const { cartTotalGross, orderFromOfferTotalGross } = useCart()
    const { creditInfo } = useCustomer()
    const { orderItemsFromOffer } = useOffers()

    let grosTotalPrice = orderItemsFromOffer.length > 0 ? orderFromOfferTotalGross : cartTotalGross
    const isCreditRemain = !creditInfo || (creditInfo.remainCredit - grosTotalPrice) <= 0 ? false : true

    const [showPaymentModal, setShowPaymentModal] = useState(false)

    const paymentLinkStyle = authState.user.isOperator ? '' : ''

    if (!creditInfo || creditInfo.grantCredit === 0) {
        return null
    }
    return (
        <>
            <PaymentDataModal
                show={showPaymentModal}
                onHide={() => setShowPaymentModal(false)}
            />
            <div className="col-6 d-flex flex-column mb-3 mb-lg-0">
                <CheckBox
                    textPosition="before"
                    text='Limit kredytowy'
                    className="custom-checkbox"
                    onValueChange={() => handleCheckboxChange('Limit kredytowy', 'payment')}
                    value={orderInfo.payment === 'Limit kredytowy'}
                    readOnly={isCreditRemain ? false : true}
                    style={{ order: 1 }}
                />
                {!isCreditRemain ? (
                    <div className='d-flex flex-column' style={{ order: 22 }}>
                        <span className='error-text-color'>Nie masz wystarczającego limitu kredytowego</span>
                        <span className={`${paymentLinkStyle} app-link`} onClick={() => setShowPaymentModal(true)}>Pobierz dane do przelewu</span>
                    </div>) : (null)}
                <span style={{ order: 23 }}>Twój limit kredytowy wynosi: {ConvertPriceToString(creditInfo.remainCredit)}</span>

            </div>
        </>
    )
}

const AttachmentSection = ({ orderInfo, setOrderInfo }) => {
    const { isDragging, getRootProps, getInputProps } = useAttachmentUploader()

    const popover = <Popover id="popover-basic">
        <Popover.Body className="text-center">
            <span className='primary-accent-color-text'>.pdf .docx .txt max 5MB max 5 plików</span>
        </Popover.Body>
    </Popover>

    const handleDeleteAttachments = (name) => {
        setOrderInfo(prevOrderInfo => {
            const newAttachments = prevOrderInfo.attachments.filter(
                attachment => attachment.name !== name
            )
            return {
                ...prevOrderInfo,
                attachments: newAttachments
            }
        })
    }

    if (orderInfo.attachments.length === 0) {
        return (
            <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover}>
                <div {...getRootProps()} className='d-flex flex-column align-items-center'>
                    <input {...getInputProps()} />
                    <img src={'/Icons/uploadImg.svg'} alt='upload' style={{ maxWidth: '100px', maxHeight: '100px', objectFit: 'contain' }}
                        onError={(e) => {
                            e.target.src = '/Icons/uploadImg.svg'
                        }}
                    />
                    <span className='app-link'>Dodaj załącznik</span>
                </div>
            </OverlayTrigger>
        )
    }
    else {
        return (
            <div className='dotted-container'>
                <div className="row">
                    <div className="col">
                        {orderInfo.attachments.map((e, key) => (
                            <div key={key}>
                                <MdClear size={25} className='error-text-color element-pointer me-2' onClick={() => handleDeleteAttachments(e.name)} />
                                <span>{e.name}</span>
                            </div>
                        ))}
                    </div>
                    <div className="col-4">
                        <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover}>
                            <div {...getRootProps()} className='d-flex flex-column align-items-center'>
                                <input {...getInputProps()} />
                                <img src={'/Icons/uploadImg.svg'} alt='upload' style={{ maxWidth: '100px', maxHeight: '100px', objectFit: 'contain' }}
                                    onError={(e) => {
                                        e.target.src = '/Icons/uploadImg.svg'
                                    }}
                                />
                                <span className='app-link'>Dodaj załącznik</span>
                            </div>
                        </OverlayTrigger>
                    </div>
                </div>
            </div>
        )
    }
}

export default DeliveryAndPayment